import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

export interface LocationDetailRow {
  campaignTitle: string;
  locations: string;
  hasDiff: boolean;
}

@Component({
  selector: 'app-location-detail-dialog',
  templateUrl: './location-detail-dialog.component.html',
  styleUrls: ['./location-detail-dialog.component.scss'],
  imports: [
    MatDialogModule,
    MatTableModule,
    MatIconModule,
    MatButtonModule,
  ]
})
export class LocationDetailDialogComponent {
  dialogRef = inject(MatDialogRef<LocationDetailDialogComponent>);
  data = inject<{ programName: string; rows: LocationDetailRow[] }>(MAT_DIALOG_DATA);

  displayedColumns = ['campaignTitle', 'locations'];
}
